/*                                                                           */
import.meta.glob("./common/performance.ts", { eager: true });

import { isOnexVariant } from "@otto-ec/global-resources/onex";

/*                                             */
import "@otto-ec/design-tokens/theme/theme.scss";

import.meta.glob("./common/extendCustomElement.ts", { eager: true });
import.meta.glob("./css-only-components/**/*.global.scss", { eager: true });
import.meta.glob("./fragments/**/*.global.scss", { eager: true });
import.meta.glob("./components/**/*.global.scss", { eager: true });

/*                                                                        */
import.meta.glob("./components/**/*.sync.svelte", { eager: true });

if (isOnexVariant("E3619", "Testgroup")) {
  document.documentElement.dataset.onex = "yeah";
}
